import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"close\">\n  <path d=\"M7.5 6.086 12.803.782l1.415 1.415L8.914 7.5l5.304 5.303-1.415 1.415L7.5 8.914l-5.303 5.304-1.415-1.415L6.086 7.5.782 2.197 2.197.782 7.5 6.086z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol